import { render } from "./Upload.vue?vue&type=template&id=6ad76ae5&scoped=true"
import script from "./Upload.vue?vue&type=script&lang=js"
export * from "./Upload.vue?vue&type=script&lang=js"

import "./Upload.vue?vue&type=style&index=0&id=6ad76ae5&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6ad76ae5"

export default script